import React from "react";
import {Button} from "react-bootstrap";
import DateRangeFilter from "../../../../components/FilterField/DateRangeFilter";
import Moment from "react-moment";
import {hilightTableAdvancedService} from "../../../../services/hilight-table-advanced.service";
import JSONPretty from "react-json-pretty";
import HilightTableAdvanced from "../../../../components/HilightTableAdvanced";
import {withNamespaces} from "react-i18next";
import DeviceLogFilter from "../_filters/DeviceLogFilter";
import SelectFilter from "../../../../components/FilterField/SelectFilter";

const LogDeviceTable = ({t}) => {

    const fetchIdRef                = React.useRef(0);
    const [data, setData]           = React.useState([]);
    const [loading, setLoading]     = React.useState(false);
    const [pageCount, setPageCount] = React.useState(0);
    const [itemCount, setItemCount] = React.useState(0);

    const [requestUrlParams, setRequestUrlParams] = React.useState({});

    const apiUrl = `/api/logs/GetEventLog`;

    const columns = [
        {
            Header: '',
            id: 'expander',
            disableFilters: true,
            Cell: ({ row }) => (
                <span {...row.getToggleRowExpandedProps()}>
                    {row.isExpanded ? (
                        <Button size={"sm"} variant={"outline-info"}>
                            <i className="fas fa-arrow-right"/>
                        </Button>
                    ) : (
                        <Button size={"sm"} variant={"outline-info"}>
                            <i className="fas fa-arrow-down"/>
                        </Button>
                    )}
                </span>
            )
        },
        {
            Header: 'hash',
            accessor: 'id',
            disableFilter: true
        },
        {
            Header: 'network-device',
            accessor: 'networkDeviceLabel',
        },
        {
            Header: 'insert-data',
            accessor: 'insertDate',
            Filter: DateRangeFilter,
            Cell: (props) => {
                const data = props.row.original;
                return <Moment format="YYYY-MM-DD HH:mm:ss">{data.insertDate}</Moment>
            }
        },
        {
            Header: 'className',
            accessor: 'className'
        },
        {
            Header: 'logType',
            accessor: 'logType',
            Filter: SelectFilter,
            filterOptions: [
                'Error',
            ]
        },
        {
            Header: 'message',
            accessor: 'message'
        }
    ];

    const fetchData = React.useCallback(({ urlParams, pageSize }) => {
        const fetchId = ++fetchIdRef.current;
        setLoading(true);
        if (fetchId === fetchIdRef.current) {
            hilightTableAdvancedService.getHilightTableRequest(apiUrl, urlParams)
                .then((resultData) => {
                    setRequestUrlParams(urlParams);
                    setData(resultData.logs);
                    setLoading(false);
                    setItemCount(resultData.allItemsCount);
                    setPageCount(Math.ceil(resultData.allItemsCount / pageSize));
                });
        }
    }, []);

    const renderRowSubComponent = (row) => {
        const json = JSON.parse(row.original.stackTrace);
        return (
            <JSONPretty id={"row.original.id"} data={json} />
        )
    };

    return (
        <div className="col-md-12 mx-0 my-3 p-0">
            <HilightTableAdvanced
                columns={columns}
                data={data}
                fetchData={fetchData}
                loading={loading}
                pageCount={pageCount}
                itemCount={itemCount}
                renderRowSubComponent={renderRowSubComponent}
                filterModel={DeviceLogFilter}
            />
        </div>
    )
};
export default withNamespaces()(LogDeviceTable);
